import { CustomerModel, CustomerNoteModel } from '@/models/customer';
import { TagType } from '@/models/tag';

export function getCustomerTags({ customerTags }: CustomerModel, filterType?: TagType) : string[] {
  const result = new Set<string>();

  customerTags?.forEach(({ tag }) => {
    if (tag !== undefined) {
      if (filterType === undefined || tag.type === filterType && result.has(tag.label) === false) {
        result.add(tag.label);
      }
    }
  });

  return [...result.values()];
}

export function getNoteTags(note: CustomerNoteModel) : string[] {
  const { customerNoteTags = [] } = note;

  return customerNoteTags
    .flatMap(({ tag = [] }) => tag)
    .map(({ label }) => label);
}
